import { mapGetters, mapActions } from 'vuex'
import './userPopover.scss'
import { openSourceLink } from '@/utils/common'
import cardImg from '@/assets/images/card.png'
import subscribeImg from '@/assets/images/subscribe.png'
import rankImg from '@/assets/images/rank.png'
import auditImg from '@/assets/images/audit.png'


export default {
    name: 'NoticePopover',

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            visible: this.value,
            cardImg,
            subscribeImg,
            rankImg,
            auditImg
        }
    },

    computed: {
        ...mapGetters('common', [
            'userInfo'
        ])
    },

    watch: {
        visible(val) {
            this.$emit('input', val)
        }
    },

    mounted() {
        // this.fetchUserInfo()
    },

    methods: {
        ...mapActions('common', [
            'fetchUserInfo',
            'logout'
        ]),
        morePower() {
            this.$router.push('/main/buy')
            // const url = Config.loginUrl + '/#/dc/buy'
            // openSourceLink(url)
            // // window.open(url, '_blank')
        },
        async signup() {
            await this.logout()
            localStorage.removeItem('yt-dc-token')
            localStorage.removeItem('yt-dc-buy-from')
            this.$router.push('/dcLogin')

            // const res = await this.logout()
            // if (res.data.ErrorCode === 200) {
            //     localStorage.removeItem('yt-dc-token')
            //     if (process.env.NODE_ENV == 'production') {
            //         window.location.href = Config.loginUrl + '/#/login?from=http://yuntudc.cricbigdata.com/login&systemName=云图洞察'
            //     } else {
            //         window.location.href = Config.loginUrl + '/#/login?from=http://' + window.location.host + '/login&systemName=云图洞察'
            //     }
            //     // window.location.href = Config.loginUrl
            // } else {
            //     this.$message({
            //         type: 'error',
            //         message: res.data.ErrorMessage
            //     })
            // }
        },
        goUserCenter() {
            this.$router.push('/my/product')
            // const url = Config.loginUrl + '/#/my/product'
            // openSourceLink(url)
            // // window.open(url, '_blank')
        }
    },

    render() {
        return (
            <el-popover
                v-model={this.visible}
                width='340'
                trigger='hover'
                placement='bottom'
                popper-class='userPopper_wrap'
            >
                <div slot='reference'>{this.$slots.reference}</div>
                <div class='userInfo-wrap'>
                    <div class='info-wrap' style={`background-image: url(${this.cardImg});`}>
                        {
                            this.userInfo.aInfoData && (
                                <div class='info'>
                                    <div class='avatar'>
                                        {this.userInfo.aInfoData.sAvatar !== '' && (
                                            <el-avatar src={this.userInfo.aInfoData.sAvatar} size={40} />
                                        )}
                                        {this.userInfo.aInfoData.sAvatar === '' && (
                                            <el-avatar icon='el-icon-user-solid' size={40} />
                                        )}
                                    </div>
                                    <div class='username'>
                                        <i class='iconfont iconhuiyuan' />
                                        {this.userInfo.aInfoData.sNickName}
                                    </div>
                                    {/* <div class='text company'>公司名称：{this.userInfo.aInfoData.sCompany}</div> */}
                                    <div class='date text'>
                                        {/* 到期时间：{this.userInfo.aInfoData.sVipStartDate.replace(/-/g, '.')}-{this.userInfo.aInfoData.sVipEndDate.replace(/-/g, '.')} */}
                                        {/* <span class='btn' onClick={this.morePower}>立即续费</span> */}
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div class='vip'>
                        {/* <div class='vip-header'>
                            <div class='title'>VIP特权</div>
                            <el-button type='text' size='mini' onClick={this.morePower}>更多&gt;</el-button>
                        </div> */}
                        {
                            (this.userInfo.aSubInfo || this.userInfo.aReadInfo || this.userInfo.aCustomInfo) && (
                                <div class='vip-wrap'>
                                    <div class='vip-item'>
                                        <div class='icon'>
                                            <el-image src={this.subscribeImg} style='width: 30px; height: 30px;' />
                                        </div>
                                        <div class='amount'>
                                            <span class='current'>{this.userInfo.aSubInfo.iCnt}</span>
                                            <span class='total'>/{this.userInfo.aSubInfo.iTotal}</span>
                                        </div>
                                        <div class='label'>个性化订阅</div>
                                    </div>
                                    <div class='vip-item'>
                                        <div class='icon'>
                                            <el-image src={this.auditImg} style='width: 30px; height: 30px;' />
                                        </div>
                                        <div class='amount'>
                                            <span class='current'>{this.userInfo.aReadInfo.iCnt}</span>
                                            <span class='total'>/{this.userInfo.aReadInfo.iTotal}</span>
                                        </div>
                                        <div class='label'>阅读数监控</div>
                                    </div>
                                    <div class='vip-item'>
                                        <div class='icon'>
                                            <el-image src={this.rankImg} style='width: 30px; height: 30px;' />
                                        </div>
                                        <div class='amount'>
                                            <span class='current'>{this.userInfo.aCustomInfo.iSubCnt}</span>
                                            <span class='total'>/{this.userInfo.aCustomInfo.iTotal}</span>
                                        </div>
                                        <div class='label'>自定义榜单</div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div class='action'>
                        <div class='btn' onClick={this.signup}>
                            <i class='iconfont icontuichu' />
                            退出系统
                        </div>
                        {/* <div class='btn' onClick={this.goUserCenter}>进入个人中心&gt;</div> */}
                    </div>
                </div>
            </el-popover>
        )
    }
}
